import styled from 'styled-components';

export const FooterCss = styled.div`
  width: 100%;
  position: relative;
  padding: 0;
  margin: 0;
  z-index: 8;

  .typingCaret {
    display: inline-block;
    margin-left: 2px;
    animation: blinkCaret 0.8s step-end infinite;
  }

  /* =========================
     BLOCO 1
  ========================= */
  .contactTop {
    position: relative;
    background: #80edff;
    padding: 42px 0 56px;
  }

  .decor--topLeft {
    top: -30px;
    left: 0;
    width: 260px;
    height: 180px;
  }

  .decor--topLeft .decor__piece--white {
    top: 0;
    left: 0;
    width: 170px;
    transform: translate3d(-180px, 0, 0);
    transition: transform 1.8s ease, opacity 1.8s ease;
  }

  .decor--topLeft.is-active .decor__piece--white {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }

  .setaScroll {
    position: absolute;
    top: -50px;
    right: 90px;
    width: 102px;
    z-index: 1;
    pointer-events: none;
    transform-origin: 72% 28%;
    will-change: transform;
    transition: transform 0.08s linear;
  }

  .teamGrid {
    display: grid;
    grid-template-columns: 140px 1fr 1.2fr;
    align-items: center;
    gap: 34px;
    min-height: 460px;
  }

  .teamTitle {
    color: #ff1a00;
    font-weight: 700;
    font-size: 22px;
    line-height: 0.95;
    opacity: 0;
    transform: translate3d(-60px, 0, 0);
    transition: opacity 0.9s ease, transform 0.9s ease;
    align-self: center;
    justify-self: start;
    white-space: pre-line;
  }

  .teamTitle span {
    display: block;
  }

  .teamTitle.is-active {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }

  .teamPhotoWrap {
    opacity: 0;
    transform: translate3d(0, -70px, 0);
    transition: opacity 1s ease, transform 1s ease;
    justify-self: center;
    width: 100%;
    max-width: 360px;
  }

  .teamPhotoWrap.is-active {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }

  .teamPhoto {
    display: block;
    width: 100%;
    height: auto;
    object-fit: cover;
  }



  /* =========================
     BLOCO 2
  ========================= */
  .contactBottom {
    position: relative;
    background: #efe7d4;
    padding: 10px;
  }

  .bottomZWrap {
    position: absolute;
    left: 28px;
    top: -20px;
    width: 120px;
    height: 120px;
    pointer-events: none;
    z-index: 1;
  }

  .bottomZ {
    width: 100%;
    opacity: 0;
    transform: translate3d(180px, 0, 0);
    transition: transform 2.2s ease, opacity 2.2s ease;
  }

  .bottomZWrap.is-active .bottomZ {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }

  .tarjaWrap {
    position: absolute;
    top: -92px;
    right: 0;
    width: 210px;
    pointer-events: none;
    z-index: 1;
    opacity: 0;
    transform: translate3d(-100px, 0, 0);
    transition: opacity 1s ease, transform 1s ease;
  }

  .tarjaWrap.is-active {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }

  .tarjaVermelha {
    width: 100%;
    display: block;
  }

  .vamosFalarTitle {
    text-align: center;
    font-size: 58px;
    line-height: 1;
    font-weight: 700;
    padding: 0;
    margin: 0 0 40px;
    color: #ff1a00;
    position: relative;
    z-index: 2;
  }

  
  /* =========================
     FOOTER
  ========================= */
  .footerBar {
    width: 100%;   
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: 24px;
    position: relative;
    z-index: 2;
	padding: 20px 0
  }

  #redes {
    display: flex;
    align-items: center;
    gap: 16px;
    font-size: 24px;
    font-weight: 300;
  }

  #redes a {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  #redes img {
    opacity: 0.75;
    transition: 0.2s;
    cursor: pointer;
    width: 22px;
  }

  #redes img:hover {
    opacity: 1;
    transform: translateY(-1px) scale(1.08);
  }

  #logotipos {
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    gap: 32px;
    flex-wrap: nowrap;
  }

  #logotipos img {
    height: auto;
    object-fit: contain;
  }

  #logotipos img:first-child {
    max-width: 132px;
  }

  #logotipos img:last-child {
    max-width: 104px;
  }

  /* =========================
     RESPONSIVO
  ========================= */
  @media only screen and (max-width: 1100px) {
    .teamGrid {
      grid-template-columns: 110px 300px 1fr;
      gap: 24px;
    }

    .teamText {
      font-size: 16px;
      max-width: 360px;
    }

    .vamosFalarTitle {
      font-size: 50px;
    }

    .setaScroll {
      width: 95px;
      right: 46px;
    }
  }

  @media only screen and (max-width: 900px) {
    .contactTop {
      padding: 52px 0 44px;
    }

    .teamGrid {
      grid-template-columns: 1fr;
      gap: 22px;
      min-height: auto;
      justify-items: center;
      text-align: center;
    }

    .teamTitle {
      justify-self: center;
      font-size: 34px;
      line-height: 0.9;
    }

    .teamPhotoWrap {
      max-width: 320px;
    }

    .teamTextWrap {
      min-height: auto;
      justify-content: center;
    }

    .teamText {
      text-align: left;
      max-width: 420px;
    }

    .vamosFalarTitle {
      font-size: 44px;
    }

    .footerBar {
      flex-direction: column;
      align-items: center;
      gap: 26px;
    }

    #logotipos {
      justify-content: center;
    }

    .tarjaWrap {
      width: 150px;
	  top:-50px
    }
  }

  @media only screen and (max-width: 768px) {
    .container {
      padding: 0 18px;
    }

    .decor--topLeft {
      width: 180px;
      height: 120px;
    }

    .decor--topLeft .decor__piece--white {
      width: 110px;
    }

    .setaScroll {
      width: 70px;
      top: -22px;
      right: 70px;
    }

    .teamTitle {
      font-size: 28px;
    }

    .teamPhotoWrap {
      max-width: 270px;
    }

    .teamText {
      font-size: 15px;
      line-height: 1.5;
    }

    .contactBottom {
      padding: 62px 0 28px;
    }

    .bottomZWrap {
      width: 78px;
      left: 14px;
       top: -20px;
    }

    .vamosFalarTitle {
      font-size: 36px;
      margin-bottom: 28px;
    }

    #formulario input[type="text"],
    #formulario textarea {
      font-size: 18px;
      height: 52px;
      margin-bottom: 14px;
    }

    #formulario textarea {
      min-height: 82px;
    }

    #formulario button {
      width: 120px;
      height: 42px;
      font-size: 18px;
    }

    #redes {
      gap: 14px;
    }

    #logotipos {
      gap: 20px;
      flex-wrap: wrap;
    }

    #logotipos img:first-child {
      max-width: 120px;
    }

    #logotipos img:last-child {
      max-width: 92px;
    }
  }

  @media only screen and (max-width: 480px) {
    .contactTop {
      padding: 46px 0 38px;
    }

    .teamTitle {
      font-size: 24px;
    }

    .teamPhotoWrap {
      max-width: 220px;
    }

    .teamText {
      font-size: 14px;
    }

    .vamosFalarTitle {
      font-size: 30px;
    }

    .tarjaWrap {
      width: 118px;
    }

    #formulario input[type="text"],
    #formulario textarea {
      font-size: 16px;
      padding: 0 12px;
    }

    #formulario textarea {
      padding-top: 14px;
    }

    #redes img {
      width: 20px;
    }

    #logotipos img:first-child {
      max-width: 108px;
    }

    #logotipos img:last-child {
      max-width: 86px;
    }
  }
`;